export const PRECHAT_FIELD_TYPE_EMAIL_CONSENT = 'emailConsent';
export const PRECHAT_FIELD_TYPE_DEPARTMENT_ID = 'department_id';
export const PRECHAT_GDPR_CONSENT_ID = 'gdprConsent';
